import React, { useContext } from 'react';
import cx from 'classnames';
import BiddingContext from 'modules/bidding/context';
import { FormatPrice } from 'utils/format';
import { Loading } from 'components/Loading';

import { Feedback } from '@ontruck/orc';

import BiddingListItem from './list-item';
import MaxCostChanges from '../max-cost-changes';

const t = {
  no_bids_found: 'No bids found',
  assigned: 'Job assigned to',
  at: 'at',
  error: 'There was an error assigning the Job',
  driver: 'Driver',
  scoring: 'Scoring',
  bid: 'Bid',
  margin: 'Margin',
};

const BiddingList = ({ className, showRejected }) => {
  const {
    listOfBids,
    listOfRejectedBids,
    maxCostChanges,
    callEventAction,
    assignAction,
    isTriggeringAction,
    isBidAccepted,
    error,
  } = useContext(BiddingContext);

  const isLoading = !listOfBids;

  const { driverAssigned, bidCost, bidCurrency } = isBidAccepted || {};
  let bids = listOfBids;

  if (isTriggeringAction) {
    return (
      <div className={cx(className, 'loading')}>
        <Loading className="loading" light />
      </div>
    );
  }

  if (!!isBidAccepted) {
    return (
      <div className={cx(className, 'success')}>
        <Feedback size="wideS" skin="success">
          {t.assigned} {driverAssigned} {t.at}{' '}
          <FormatPrice currency={bidCurrency} value={bidCost} />
        </Feedback>
      </div>
    );
  }

  if (showRejected === true) {
    bids = listOfRejectedBids;
  }

  return (
    <div className={className}>
      {!!error && (
        <div className="error">
          <Feedback size="wideS" skin="error">
            {t.error}
          </Feedback>
        </div>
      )}
      {isLoading && <Loading className="loading" light />}
      {!isLoading && !bids?.length && <div className="zero-results">{t.no_bids_found}</div>}
      {!isLoading && (
        <>
          {!showRejected && <MaxCostChanges changes={maxCostChanges} />}
          <div className="list_item_container">
            {!!bids?.length && (
              <div className="list_item_header">
                <div className="name">{t.driver}</div>
                <div className="scoring">{t.scoring}</div>
                <div className="bid">{t.bid}</div>
                <div className="bid">{t.margin}</div>
                <div />
              </div>
            )}
            {bids?.map((bid) => (
              <BiddingListItem
                key={bid?.id}
                bid={bid}
                onCallClick={callEventAction}
                onAssignClick={assignAction}
                disabled={isTriggeringAction}
                isRejected={showRejected}
                data-testid="bidding-list-item"
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default BiddingList;
